import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './accordion-tw-styles';

class AccordionPanel extends React.PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };

  render() {
    const { className, accordionStyle, children, ...other } = this.props;
    let accordionStyles = {};
    if (accordionStyle !== undefined) {
      accordionStyles = accordionStyle;
    } else {
      accordionStyles = styles;
    }
    return (
      <div
        className={classNames(accordionStyles.accordion.panel, className)}
        {...other}
      >
        {children}
      </div>
    );
  }
}

export default AccordionPanel;
